<template>
  <markdown-view-teacher id="question-text" :raw-text="rawText" :work-id="workId" ref="refMarkdownView"></markdown-view-teacher>
</template>

<script setup lang="ts">
  import {ref, onMounted, onUpdated, nextTick} from "vue";

  const props = defineProps<{
    workId: number;
    rawText: string;
    prefix: string;
  }>()
  const refMarkdownView = ref(null)
  onMounted(() => {
    formatQuestionText()
  })

  onUpdated(() => {
    formatQuestionText()
  })

  function formatQuestionText() {
    nextTick(() => {
      const questionText = document.getElementById("question-text")
      Array.prototype.forEach.call(questionText.children, function (ele) {
        ele.outerHTML = ele.outerHTML.replace(/^<p>|<\/p>$/, "")
      })
      refMarkdownView.value.$el.innerHTML = props.prefix + " " + refMarkdownView.value.$el.innerHTML
    })
  }
</script>

<style lang="scss" scoped>
</style>
